import { Link } from 'react-router-dom';

/**
 * Refund policy. Public page. Referenced from the landing page checkout copy
 * and the footer. Short, direct, no legalese.
 */
export default function RefundsPage() {
  return (
    <div className="mx-auto max-w-2xl px-6 py-16">
      <p className="font-mono text-xs uppercase tracking-widest text-amber">Refund policy</p>
      <h1 className="mt-3 text-3xl font-semibold tracking-tight">
        14 day money back guarantee.
      </h1>

      <p className="mt-6 text-muted leading-relaxed">
        We want you to feel confident enrolling. If Constare Academy is not the
        right fit for you, we will refund you in full within 14 days of your
        purchase. No questions asked.
      </p>

      <div className="mt-10 space-y-6">
        <section>
          <h2 className="text-xl font-semibold text-text">How to request a refund</h2>
          <p className="mt-2 text-muted">
            Email{' '}
            <a
              href="mailto:marshall@constare.academy"
              className="text-amber hover:underline"
            >
              marshall@constare.academy
            </a>{' '}
            from the address you paid with. Include your order or the email address
            you used at checkout. We process refunds within 3 business days back to
            the original payment method.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-text">After 14 days</h2>
          <p className="mt-2 text-muted">
            After the 14 day window closes, refunds are only granted for technical
            reasons: platform outages that prevent access, or bugs we cannot fix.
            Change of mind is not a technical reason. If you are not sure whether
            your situation qualifies, email us and we will look at it.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-text">What happens to your account</h2>
          <p className="mt-2 text-muted">
            When a refund is issued, your account is closed automatically and you
            lose access to lesson content. Any writing you saved in the platform
            stays in our database for 30 days in case you change your mind, then it
            is deleted.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-text">Questions before you buy</h2>
          <p className="mt-2 text-muted">
            Email{' '}
            <a
              href="mailto:marshall@constare.academy"
              className="text-amber hover:underline"
            >
              marshall@constare.academy
            </a>
            . A real person reads that inbox.
          </p>
        </section>
      </div>

      <div className="mt-12">
        <Link to="/" className="text-sm text-amber hover:underline">
          Back to home
        </Link>
      </div>
    </div>
  );
}
